import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom"; // Importe useHistory
import { useUser } from "../../context/userContext";
import HowToUseGrammarDialog from "components/Dialogs/HowToUseGrammarDialog";
import ErrorListener from "../../g4/ErrorListener";
import DataService from "../../services/DataService.js";
import { useGrammar } from "../../context/grammarContext";
import { useSystem } from "../../context/systemContext";
import "./grammar.css";
import { Button, Grid } from "@material-ui/core";
import EssentialsFormatText from "utils/EssentialsFormatText";
import { useAlert } from "context/Feedback/alertContext";
import constants from "../../constants/Grammar/inputGrammar";
import constantsNavbar from "../../constants/navbarOptions";
import HistoricalGRammarDialog from "components/Dialogs/HistoricalGrammarDialog";
import SystemOff from "views/System/SystemOff";
import ImportGrammarDialog from "components/Dialogs/ImportGrammarDialog";
import { formatBackDate } from "../../utils/Formatter";

export default function Grammar() {
  const history = useHistory(); // Use o hook useHistory para navegação programática

  const {
    originalGrammar,
    setOriginalGrammar,
    grammarName,
    setGrammarName,
    grammarCreatedDate,
    setGrammarCreatedDate,
    setResponseOriginalGrammar,
  } = useGrammar();

  useEffect(() => {
    onChange(originalGrammar);
  }, [originalGrammar]);

  const { isAlive } = useSystem();
  const { user, setUser, language, credential, isAdmin } = useUser();

  const [titleModal] = useState("");
  const [startPosClick, setStartPosClick] = useState(0);
  const [keyPress, setKeyPress] = useState(0);
  const [posCursorUser, setPosCursorUser] = useState(null);
  const placeholder = {
    en: "Grammar",
    pt: "Gramática",
  };
  // eslint-disable-next-line no-unused-vars
  const [_isDisable, setIsDisable] = useState(true);
  const [buttonClass, setButtonClass] = useState("bt-disabled");
  // eslint-disable-next-line no-unused-vars
  const [_anchorClass, setAnchorClass] = useState("anchor-grammar-disabled");
  const [errorMessages, setErrorMessages] = useState("Gramática vazia");
  const { setAlert } = useAlert();

  function onChange(values) {
    if (typeof values !== "string") return;
    const MAX_PRODUCTIONS = 200; // Limite total de regras
    const ruleLines = values.split("\n");
    let productionCount = 0;
    for (const line of ruleLines) {
      if (line.includes("→")) {
        const parts = line.split("→");
        if (parts[1]) {
          productionCount += parts[1].split("|").length;
        }
      }
    }
    if (productionCount > MAX_PRODUCTIONS) {
      setAlert({
        active: true,
        text: `${constants.alert.rulesLimitMessage[language]}${MAX_PRODUCTIONS}`,
        color: "danger",
        severity: "error",
      });
      return;
    }
    try {
      //Substitui ->, → &/ou ., λ

      let tempGrammar = values
        .split("->")
        .join("→")
        .split(" -> ")
        .join(" → ")
        .split(" ->")
        .join(" →")
        .split(".")
        .join("λ")
        .split("`")
        .join("'")
        .split("'")
        .join("'")
        .split('"')
        .join("'")
        .split("''")
        .join("'")
        .split("	")
        .join(" ")
        .split("\n\n")
        .join("");

      let arrFormat = EssentialsFormatText.preparerText(tempGrammar, keyPress);

      tempGrammar = arrFormat[0];
      setOriginalGrammar(tempGrammar);

      if (arrFormat[1] !== null) {
        setPosCursorUser(arrFormat[1]);
      }

      if (validation(tempGrammar)) {
        setErrorMessages("");
        setButtonClass("bt-success");
        setIsDisable(false);
        setAnchorClass("anchor-grammar-success");
      } else {
        setIsDisable(true);
        setButtonClass("bt-disabled");
        setAnchorClass("anchor-grammar-disabled");
      }
    } catch (e) {
      console.error(e);
    }
  }

  function verificationSemantic(txt) {
    let rules = txt.split("\n");
    let tmp = "";

    let rightSide = [];
    for (let rule of rules) {
      let aux = rule.replace(/ /g, "");

      aux = aux.split("→");
      if (aux.length > 1) {
        aux = aux[1].split("|");
        for (let v of aux) {
          rightSide.push(v);
        }
      }
    }

    let variablesTemp = new Set();
    let popped;

    for (let r of rules) {
      tmp = r.split("→");

      //match S' | S
      let tempArr = tmp[0]
        .trim()
        .match(/([A-Z](₀|₁|₂|₃|₄|₅|₆|₇|₈|₉)+)|([A-Z]')|[A-Z]/g);

      //Em caso de ter \n vazio
      if (tempArr) {
        for (let letters of tempArr) variablesTemp.add(letters);
      }
    }

    variablesTemp = Array.from(variablesTemp);

    variablesTemp.reverse();
    popped = variablesTemp.pop();

    //Lista de regra da direita do S -> A
    let listRule = [];
    let leftSide = variablesTemp;
    leftSide.push(popped);
    let eqif = true;
    for (let v of rightSide) {
      let lettersUpRightSide = v
        .trim()
        .match(/([A-Z](₀|₁|₂|₃|₄|₅|₆|₇|₈|₉)+)|([A-Z]')|[A-Z]/g);

      if (lettersUpRightSide) {
        //Se RightSide vazio

        for (let l of lettersUpRightSide) {
          if (!leftSide.includes(l)) {
            listRule.push(l);
            eqif = false;
          }
        }
      }
    }

    if (!eqif) {
      let subtractionElem = [];

      listRule.every((elem) => {
        if (!variablesTemp.includes(elem)) {
          subtractionElem.push(elem);
        }
        return 0;
      });

      let letter = subtractionElem.toString();
      return [false, letter];
    }

    rules = txt.split("\n");
    for (let rule of rules) {
      if (rule.split("→").length >= 2) {
        let leftSide = rule.split("\n")[0].split("→")[0].trim();

        let irregularRule = rule
          .split("\n")[0]
          .split("→")[1]
          .split("|")
          .every((rightSide) => {
            if (rightSide.trim().length > 1) {
              return rightSide
                .trim()
                .split("")
                .every((letter) => {
                  if (letter.trim() === leftSide) return true;
                });
            } else {
              if (rightSide.trim() === leftSide) return true;
            }
            return false;
          });
        if (irregularRule) {
          return [false, rule, "Only left and right side equals"];
        }
      }
    }

    return [true, ""];
  }
  const validation = (grammarText) => {
    try {
      //Inicializando ANTLR4 framework
      const antlr4 = require("antlr4");

      const grammarLexer = require("../../g4/grammarLexer").grammarLexer;
      const grammarParser = require("../../g4/grammarParser").grammarParser;

      const grammarParserListener = require("../../g4/grammarParserListener")
        .grammarParserListener;

      //Instanciando métodos do ANTLR4
      let input = grammarText;
      let chars = new antlr4.InputStream(input);
      let lexer = new grammarLexer(chars);
      lexer.strictMode = false;
      lexer.removeErrorListeners();
      lexer.addErrorListener(new ErrorListener()); //Get errors of tokens
      let tokens = new antlr4.CommonTokenStream(lexer);
      let parser = new grammarParser(tokens);

      //Instânciando o Parser para custom métodos.
      parser.buildParseTrees = true;
      let errorListerner = new ErrorListener();
      let semanticError = verificationSemantic(grammarText);

      parser.addParseListener(new grammarParserListener(grammarText));
      parser.removeErrorListeners(); // Remove default ConsoleErrorListener
      parser.addErrorListener(errorListerner); // Add custom error listener
      try {
        parser.compilationUnit();
      } catch (e) {
        if (e !== "") {
          setErrorMessages(e);
        } else if (grammarText === "") {
          setErrorMessages("Gramática vazia");
        }

        return false;
      }

      if (semanticError && !semanticError[0]) {
        if (semanticError.length > 2) {
          if (language === "pt") {
            setErrorMessages(
              "Apenas lado esquerdo e direito iguais",
              semanticError[1]
            );
          } else {
            setErrorMessages(semanticError[2], ": ", semanticError[1]);
          }
        } else {
          if (language === "pt") {
            setErrorMessages(`Sua gramática não está definido ${semanticError[1]}
                            como regra da esquerda.`);
          } else {
            setErrorMessages(`Your grammar not definided ${semanticError[1]}
                            in left rule`);
          }
        }

        return false;
      }
      return true;
    } catch (e) {
      console.error(e);
    }
  };

  const formatDate = (date) => {
    const pad = (num) => String(num).padStart(2, "0");

    const d = pad(date.getDate());
    const m = pad(date.getMonth() + 1);
    const y = date.getFullYear();
    const hh = pad(date.getHours());
    const mm = pad(date.getMinutes());
    const ss = pad(date.getSeconds());

    return `${d}/${m}/${y}-${hh}:${mm}:${ss}`;
  };

  function nameExistsInList(list, name, ignoreCreatedDate) {
    return list.some(
      (item) => item.name === name && item.createdDate !== ignoreCreatedDate
    );
  }

  function verifyCreatedDate(list, dateToVerify) {
    return list.findIndex((item) => item.createdDate === dateToVerify);
  }

  async function onSubmit() {
    if (!verifyName()) {
      return;
    }
    if (!grammarName) {
      setAlert({
        active: true,
        text: constantsNavbar.alerts.info.defaultName[language],
        color: "warning",
        severity: "info",
      });
      setGrammarName(formatDate(new Date()));
    }
    if (errorMessages) {
      setAlert({
        active: true,
        text: String(errorMessages),
        color: "danger",
        severity: "error",
      });
      return;
    }

    let dados = {
      activateOtherPage: originalGrammar,
      lang: language,
      variables: originalGrammar,
    };

    const authorization = {
      headers: { Authorization: credential },
    };

    try {
      const existingIndex = verifyCreatedDate(
        user.historicalGrammar,
        grammarCreatedDate
      );

      if (
        existingIndex !== -1 &&
        nameExistsInList(
          user.historicalGrammar,
          grammarName,
          grammarCreatedDate
        )
      ) {
        setAlert({
          active: true,
          text: constantsNavbar.alerts.info.nameInUse[language],
          color: "danger",
          severity: "error",
        });
        return;
      }

      const response = await DataService.createHTML(dados, authorization);
      const hg = { variables: dados.variables, name: grammarName };
      const dateNow = new Date().toISOString();

      try {
        if (existingIndex !== -1) {
          const updateResponse = await DataService.updateHistoricalGr(
            user.email,
            hg,
            formatBackDate(grammarCreatedDate),
            authorization
          );

          setUser((prevUser) => {
            const updatedHistoricalGrammar = prevUser.historicalGrammar.map(
              (entry) => {
                if (entry.createdDate === grammarCreatedDate) {
                  return {
                    ...entry,
                    variables: hg.variables,
                    lastUpdatedDate: dateNow,
                    createdDate: updateResponse.data.createdDate,
                    name: updateResponse.data.name,
                  };
                } else {
                  return entry;
                }
              }
            );

            return { ...prevUser, historicalGrammar: updatedHistoricalGrammar };
          });

          setGrammarCreatedDate(updateResponse.data.createdDate);
          setGrammarName(updateResponse.data.name);
          setAlert({
            active: true,
            text: constants.alert.update[language],
            color: "success",
          });
        } else {
          const saveResponse = await DataService.postSaveHistoricalGr(
            user.email,
            hg,
            authorization
          );
          const formattedCreatedDate = saveResponse.data.createdDate.slice(
            0,
            23
          );

          setUser((prevUser) => {
            const updatedHistoricalGrammar = [
              {
                variables: hg.variables,
                lastUpdatedDate: dateNow,
                createdDate: formattedCreatedDate,
                name: saveResponse.data.name,
              },
              ...prevUser.historicalGrammar,
            ];

            return { ...prevUser, historicalGrammar: updatedHistoricalGrammar };
          });

          setGrammarCreatedDate(formattedCreatedDate);
          setGrammarName(saveResponse.data.name);
          setAlert({
            active: true,
            text: constants.alert.save[language],
            color: "success",
          });
          setAlert({
            active: true,
            text: constants.alert.save[language],
            color: "success",
          });
        }
      } catch (e) {
        console.error("Error updating historical grammar:", e);
      }

      setOriginalGrammar(originalGrammar);
      setResponseOriginalGrammar(response.data);

      // Navegue para a página grammarResponse após a validação bem-sucedida
      history.push("/user/grammarResponse");
    } catch (e) {
      console.error("Error submitting grammar:", e);
      alert(e);
    }
  }

  function verifyName() {
    if (!grammarName || grammarName.trim() === "") {
      setAlert({
        active: true,
        text: constantsNavbar.alerts.info.defaultName[language],
        color: "warning",
        severity: "info",
      });
      const dateNow = new Date();
      setGrammarName(formatDate(dateNow));
      return false;
    }

    const nameExists = user.historicalGrammar.some(
      (grammar) =>
        grammar.name === grammarName &&
        grammar.createdDate !== grammarCreatedDate
    );

    if (nameExists) {
      setAlert({
        active: true,
        text: constantsNavbar.alerts.info.nameInUse[language],
        color: "danger",
        severity: "error",
      });
      return false;
    }

    return true;
  }

  if (!isAlive && !isAdmin) {
    return <SystemOff />;
  }
  return (
    <div className="container-grammar">
      <HowToUseGrammarDialog gif="dd" title={titleModal} />
      <HistoricalGRammarDialog />
      <ImportGrammarDialog />
      <Grid container justifyContent="center">
        <Grid item sm={10} xs={10} lg={7}>
          <Grid container justifyContent="center">
            <Grid item sm={12} xs={12} lg={7}>
              <textarea
                id="grammar-text"
                className="input-grammar"
                placeholder={originalGrammar == "" ? placeholder[language] : ""}
                name="gramatica"
                value={originalGrammar}
                onChange={(event) => onChange(event.target.value)}
                onKeyDown={(event) => {
                  let result = EssentialsFormatText.eraserLetter(
                    event,
                    startPosClick
                  );
                  setStartPosClick(0);
                  setKeyPress(event.key);
                  setPosCursorUser(result[1]);
                  setOriginalGrammar(result[0]);
                  onChange(result[0]);
                }}
                onKeyUp={(event) => {
                  EssentialsFormatText.cursorUserPosition(
                    event,
                    startPosClick,
                    posCursorUser
                  );
                  setPosCursorUser(null);
                }}
              />
              <div className="div-button">
                <Button
                  id="bt-teste"
                  fullWidth
                  className={`wrapper-submit-button-disable ${buttonClass}`}
                  onClick={onSubmit}
                >
                  <span>{constants.menu.lSubmit[language]}</span>
                </Button>
              </div>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
}
